import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Download } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Mail className="text-brand-primary" size={24} />,
      title: "Email",
      value: "anna200224@hotmail.com",
      href: "mailto:anna200224@hotmail.com"
    },
    {
      icon: <Phone className="text-brand-primary" size={24} />,
      title: "Phone",
      value: "+44 791 866 3773",
      href: "tel:+447918663773"
    },
    {
      icon: <MapPin className="text-brand-primary" size={24} />,
      title: "Location",
      value: "Glasgow, UK",
      href: null
    },
    {
      icon: <Linkedin className="text-brand-primary" size={24} />,
      title: "LinkedIn",
      value: "Connect with me",
      href: "https://www.linkedin.com/in/anna-krat-34a17328/"
    }
  ];

  return (
    <section id="contact" className="py-24 bg-bg-page" data-testid="contact-section">
      <div className="container mx-auto px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="heading-2 text-brand-primary mb-6">Let's Connect</h2>
            <p className="body-large max-w-3xl mx-auto">
              Ready to discuss your next role or explore collaboration opportunities? I'd love to hear from you.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Contact Information */}
            <div className="team-card p-8">
              <h3 className="heading-4 text-text-primary mb-8">Get In Touch</h3>
              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start space-x-4" data-testid={`contact-info-${index}`}>
                    <div className="flex-shrink-0">{info.icon}</div>
                    <div>
                      <h4 className="body-medium text-text-primary mb-1">{info.title}</h4>
                      {info.href ? (
                        <a
                          href={info.href}
                          target={info.href.startsWith('http') ? '_blank' : undefined}
                          rel={info.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="body-small text-text-secondary hover:text-brand-primary transition-colors"
                        >
                          {info.value}
                        </a>
                      ) : (
                        <span className="body-small text-text-secondary">{info.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="/Anna-Krat-CV.pdf"
                download="Anna-Krat-CV.pdf"
                className="btn-primary w-full flex items-center justify-center gap-2 mt-8"
                data-testid="contact-download-cv-btn"
              >
                <Download size={18} />
                Download CV (PDF)
              </a>
            </div>

            {/* What I Bring */}
            <div className="team-card p-8">
              <h3 className="heading-4 text-text-primary mb-6">What I Bring</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-brand-primary rounded-full flex-shrink-0 mt-2"></div>
                  <span className="body-small text-text-primary">20+ years in product, project and digital transformation delivery</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-brand-primary rounded-full flex-shrink-0 mt-2"></div>
                  <span className="body-small text-text-primary">Enterprise-system implementation, UAT and adoption</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-brand-primary rounded-full flex-shrink-0 mt-2"></div>
                  <span className="body-small text-text-primary">Data governance, GDPR and ISO 27001-aligned controls</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-brand-primary rounded-full flex-shrink-0 mt-2"></div>
                  <span className="body-small text-text-primary">Secure workflow automation and AI-assisted internal platforms</span>
                </li>
              </ul>
              <p className="body-small text-text-secondary mt-8">
                I typically respond within 24 hours. Looking forward to connecting with you!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
